module.exports = __webpack_public_path__ + "static/media/go.e97b8362.svg";